module.exports = __webpack_public_path__ + "img/KK0042C-DB.87bf3c91.jpg";